/**
 * Product mark for Bliksys ("bliksem" — Dutch for lightning).
 *
 * The mark is a custom lightning bolt with deliberately rounded outer
 * corners (so it reads as a confident shape, not a stencil) and a
 * thinner contrast stripe along the leading edge that suggests a lit
 * surface. The stripe shrinks gracefully at small sizes — at 20px it
 * registers as a soft sheen, at 48px it's a clear highlight.
 *
 * The viewBox stays 24×24 so the mark composes with the surrounding
 * Lucide-style icon system, but the geometry is bespoke (pivots and
 * proportions diverge from the stock Lucide "zap").
 */

interface Props {
  size?: number;
  /** Override the foreground color. Defaults to currentColor. */
  color?: string;
}

export function BliksysMark({ size = 24, color }: Props): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      role="img"
      aria-hidden="true"
      style={color ? { color } : undefined}
    >
      <path
        d="M14.6 2.2 L4.4 13.6 a0.85 0.85 0 0 0 0.65 1.45 H10.4 L8.7 21.7 a0.7 0.7 0 0 0 1.22 0.55 L19.6 11 a0.85 0.85 0 0 0 -0.65 -1.45 H13.6 Z"
        fill="currentColor"
      />
      <path d="M13.6 4.6 L7.5 11.4 L9.7 11.4 L10.7 7.6 Z" fill="rgba(255,255,255,0.32)" />
    </svg>
  );
}
